export default {
  data: null,
  columns: [
    {
      label: '姓名',
      prop: 'memberName'
    },
    {
      label: '账号',
      prop: 'memberMobile'
    },
    {
      label: '会员类型',
      prop: 'memberType'
    },
    {
      label: '会员等级',
      prop: 'memberLevel'
    },
    {
      label: '日期',
      prop: 'subscribeDateStr'
    },
    {
      label: '时间段',
      prop: 'subscribeTime'
    },
    {
      label: '场地',
      prop: 'spaceName'
    },
    {
        label: '状态',
        prop: 'payStateName'
    },
    {
        label: '支付金额',
        prop: 'amount'
    },
    {
        label: '退款比例',
        prop: 'refundRate'
    },
    {
        label: '退款金额',
        prop: 'refundAmount'
    }
  ]
}
